module.exports = __webpack_public_path__ + "media/Commercial_Energetic.3d0e0e2a.mp3";